/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SandboxUsageResult,
  SandboxUsageResult$inboundSchema,
  SandboxUsageResult$Outbound,
  SandboxUsageResult$outboundSchema,
} from "./sandboxusageresult.js";

export type SandboxUsageBucket = {
  object?: "bucket" | undefined;
  startTime: number;
  endTime: number;
  results?: Array<SandboxUsageResult> | undefined;
};

/** @internal */
export const SandboxUsageBucket$inboundSchema: z.ZodType<
  SandboxUsageBucket,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("bucket").default("bucket"),
  start_time: z.number().int(),
  end_time: z.number().int(),
  results: z.array(SandboxUsageResult$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "start_time": "startTime",
    "end_time": "endTime",
  });
});
/** @internal */
export type SandboxUsageBucket$Outbound = {
  object: "bucket";
  start_time: number;
  end_time: number;
  results?: Array<SandboxUsageResult$Outbound> | undefined;
};

/** @internal */
export const SandboxUsageBucket$outboundSchema: z.ZodType<
  SandboxUsageBucket$Outbound,
  z.ZodTypeDef,
  SandboxUsageBucket
> = z.object({
  object: z.literal("bucket").default("bucket" as const),
  startTime: z.number().int(),
  endTime: z.number().int(),
  results: z.array(SandboxUsageResult$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    startTime: "start_time",
    endTime: "end_time",
  });
});

export function sandboxUsageBucketToJSON(
  sandboxUsageBucket: SandboxUsageBucket,
): string {
  return JSON.stringify(
    SandboxUsageBucket$outboundSchema.parse(sandboxUsageBucket),
  );
}
export function sandboxUsageBucketFromJSON(
  jsonString: string,
): SafeParseResult<SandboxUsageBucket, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SandboxUsageBucket$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SandboxUsageBucket' from JSON`,
  );
}
